import {
  Col,
  BPanel,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl,
  Icon,
  Table,
} from '@sketchpixy/rubix';
import { withRouter } from 'react-router';
import React from 'react';
import moment from 'moment';
import { Roles } from 'roles';

import { Meteor } from 'meteor/meteor';
import { Tracker } from 'meteor/tracker';

import { FlightIndicator } from './FlightIndicator';
import { Flights } from '../../collections/flights/flights';
import { Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import { ReservationTable } from '../reservations/components/ReservationTable';
import { Reservations } from '../../collections/reservations/reservations';
import { prepareFlight } from '../../collections/flights/methods';

@withRouter
export default class PlanningProgrammePage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};

		Tracker.nonreactive(() => {
			this.state.subscription = Meteor.subscribe('flight', this.props.params.flightId, () => {
				this.state.flight = Flights.findOne(this.props.params.flightId);



				if (!this.state.flight)
					this.props.router.push('/planning');

				this.setState({
					ready: true,
					modalInfoVisibility: false,
					montgolfiereId: this.state.montgolfiereId || (this.montgolfieres().length ? this.montgolfieres()[0]._id : null),
					temp: this.state.flight.temp || 1,
					schedulableReservations: this.schedulableReservations(),
					scheduledReservations: this.scheduledReservations(),
					schedulableReservationsSelected: new Map(),
					scheduledReservationsSelected: new Map()
				});

				if(!this.state.flight.pilotId) {
					this.updatePilot(Meteor.userId());
				}
			});
		});
	}

	componentWillUnmount() {
		if (this.state.flight && (!this.state.scheduledReservations || !this.state.scheduledReservations.length || !this.state.flight.pilotId || !this.state.montgolfiereId)) {
			Flights.remove({ _id: this.state.flight._id });
		}

		this.state.subscription.stop();
	}

	prepareFlight() {
		prepareFlight.call({
			_id: this.state.flight._id,
			place: this.state.flight.place,
			reservationIds: _.map(this.state.scheduledReservations, '_id'),
			pilotId: this.state.flight.pilotId,
			montgolfiereId: this.state.montgolfiereId,
			temp: parseInt(this.state.temp)
		}, ((err) => {
			if (err)
				return Messenger().post({
					message: err,
					type: "error"
				});

				Messenger().post({
					message: "Le vol a été preparé avec succès.",
					type: "success"
				});

				this.props.router.push('/planning?date=' + this.state.flight.date);
		}).bind(this));
	}

	updatePlace(place) {
		this.setState({ flight: _.extend(this.state.flight, { place, reservationIds: [] })});
		this.setState({
			flight: _.extend(this.state.flight, { pilotId: this.pilots().length ? this.pilots()[0]._id : null }),
			montgolfiereId: this.montgolfieres().length ? this.montgolfieres()[0]._id : null,
			schedulableReservations: this.schedulableReservations(),
			scheduledReservations: this.scheduledReservations(),
			schedulableReservationsSelected: new Map(),
			scheduledReservationsSelected: new Map()
		});
	}

	updatePilot(pilotId) {
		this.setState({ flight: _.extend(this.state.flight, { pilotId })});
		this.setState({
			montgolfiereId: this.montgolfieres().length ? this.montgolfieres()[0]._id : null,
		});
	}

	add() {
		this.setState({
			schedulableReservations: _.reject(this.state.schedulableReservations, (reservation) => {
				return _.includes(_.map([...this.state.schedulableReservationsSelected.values()], '_id'), reservation._id);
			}),
			scheduledReservations: _.concat(this.state.scheduledReservations, [...this.state.schedulableReservationsSelected.values()]),
			schedulableReservationsSelected: new Map(),
			scheduledReservationsSelected: new Map()
		});
	}

	subtract() {
		this.setState({
			schedulableReservations: _.concat(this.state.schedulableReservations, [...this.state.scheduledReservationsSelected.values()]),
			scheduledReservations: _.reject(this.state.scheduledReservations, (reservation) => {
				return _.includes(_.map([...this.state.scheduledReservationsSelected.values()], '_id'), reservation._id);
			}),
			schedulableReservationsSelected: new Map(),
			scheduledReservationsSelected: new Map()
		});
	}

	schedulableReservations() {
		const existingFlight = Flights.find({ _id: { $ne: this.state.flight._id }, status: {$ne: 'cancelled'}, place: this.state.flight.place, period: this.state.flight.period, date: moment(this.state.flight.date).startOf("day").toDate() }).fetch();
		const scheduledReservationIds = _.reduce(existingFlight, (acc, flight) => {
			return acc.concat(flight.reservationIds);
		}, []).concat(_.map(this.scheduledReservations(), '_id'));

		let reservations = Reservations.find({
			_id: { $nin: scheduledReservationIds },
			place: this.state.flight.place,
      $or: [{'periodTime': this.state.flight.period},{'period': this.state.flight.period}],
			scheduledAt: moment(this.state.flight.date).startOf("day").toDate()
		}).fetch();

    let results = _.reject(reservations, (reservation) => {
      if(reservation.period && reservation.periodTime) {
        if(reservation.periodTime != this.state.flight.period) {
          return true;
        }
      }
    });

    console.log('results', results);

    return results;

	}

	scheduledReservations() {
		return Reservations.find({
			_id: { $in: this.state.flight.reservationIds || [] },
		}).fetch();
	}

	montgolfieres() {
		const existingFlight = Flights.find({ _id: { $ne: this.state.flight._id }, place: this.state.flight.place, period: this.state.flight.period, date: moment(this.state.flight.date).startOf("day").toDate(), status: {$ne: 'cancelled' }}).fetch();
		const scheduledMontgolfiereIds = _.reduce(existingFlight, (acc, flight) => {
			acc.push(flight.montgolfiereId);
			return acc;
		}, []);

		const projection = {
			$elemMatch: {
				startDate: {$lte: this.state.flight.date},
				endDate: {$gte: this.state.flight.date},
				isAvailable: true,
				period: this.state.flight.period,
				place: this.state.flight.place
			}
		};

		return Montgolfieres.find({
			_id: { $nin: scheduledMontgolfiereIds },
			availabilities: projection,
			allowedPilots: { $in: [this.state.flight.pilotId] }
		}).fetch();
	}

	pilots() {
		const existingFlight = Flights.find({ _id: { $ne: this.state.flight._id }, place: this.state.flight.place, period: this.state.flight.period, date: moment(this.state.flight.date).startOf("day").toDate(), status: {$ne: 'cancelled' }}).fetch();
		const scheduledPilotIds = _.reduce(existingFlight, (acc, flight) => {
			acc.push(flight.pilotId);
			return acc;
		}, []);

		const projection = {
			$elemMatch: {
				startDate: {$lte: this.state.flight.date},
				endDate: {$gte: this.state.flight.date},
				isAvailable: true,
				period: this.state.flight.period,
				place: this.state.flight.place
			}
		};

		return Meteor.users.find({
			_id: { $nin: scheduledPilotIds },
			"profile.availabilities": projection,
		}).fetch();
	}

	render() {
		return (
			<div className="planning-programme">
				{this.state.ready &&
					<div>
						<Col sm={12}>
							<h3>Programmer un vol le { moment(this.state.flight.date).format("DD/MM/YYYY") }</h3><br/>
						</Col>
						<Col sm={12}>
							<Col sm={6}>
								<BPanel header="Réservations">
                <Table striped bordered condensed hover>
                  <tbody>
                    <tr>
                      <td><div className="flight-type-color" style={{backgroundColor: '#8bc34a'}}>&nbsp;</div></td>
                      <td>Vol découverte</td>
                    </tr>
                    <tr>
                    <td><div className="flight-type-color" style={{backgroundColor: '#f44336'}}>&nbsp;</div></td>
                      <td>Vol exclusif</td>
                    </tr>
                    <tr>
                      <td><div className="flight-type-color" style={{backgroundColor: '#ffeb3b'}}>&nbsp;</div></td>
                      <td>Vol soleil levant</td>
                    </tr>
                  </tbody>
                </Table>
                  {this.state.schedulableReservations.length > 0 &&
									<ReservationTable reservations={this.state.schedulableReservations} selected={this.state.schedulableReservationsSelected} />
                  }
                </BPanel>
							</Col>

							<Col sm={1} className='programmation-buttons'>
								<center>
									<Button bsStyle='green' onClick={::this.add}><Icon glyph="glyphicon-plus-sign" /></Button>
									<br/><br/>
									<Button bsStyle='red' onClick={::this.subtract}><Icon glyph="glyphicon-minus-sign" /></Button>
									<br/><br/>
								</center>
							</Col>

							<Col sm={5}>
								<BPanel header="Mon Vol">
									<Form>
										{ Roles.userHasPermission(Meteor.userId(), "flights.organize") &&
											<FormGroup controlId="formControlsSelect">
												<ControlLabel>Lieu :</ControlLabel>
												<FormControl componentClass="select" placeholder="Lieu" onChange={(e) => this.updatePlace(e.target.value)} defaultValue={this.state.flight.place}>
													<option value={"anjou"}>Anjou</option>
													<option value={"nantes"}>Nantes</option>
												</FormControl>
											</FormGroup>
										}
										{ Roles.userHasPermission(Meteor.userId(), "flights.organize") &&
											<FormGroup controlId="formControlsSelect">
												<ControlLabel>Pilote :</ControlLabel>
												<FormControl componentClass="select" placeholder="Pilote" onChange={(e) => this.updatePilot(e.target.value)} defaultValue={this.state.flight.pilotId}>
													{this.pilots().map((pilot) => {
														return (
															<option value={pilot._id}>{ pilot.profile.firstName + ' ' + pilot.profile.lastName }</option>
														);
													})}
												</FormControl>
											</FormGroup>
										}
										<FormGroup controlId="formControlsSelect">
											<ControlLabel>Montgolfiere :</ControlLabel>
											<FormControl componentClass="select" placeholder="Montgolfiere" onChange={(e) => this.setState({ montgolfiereId: e.target.value })} defaultValue={this.state.montgolfiereId}>
												{this.montgolfieres().map((montgolfiere) => {
													return (
														<option value={montgolfiere._id}>{montgolfiere.name}</option>
													);
												})}
											</FormControl>
										</FormGroup>
										<FormGroup controlId="formControlsSelect">
											<ControlLabel>Température :</ControlLabel>
											<FormControl componentClass="select" placeholder="Température" onChange={(e) => this.setState({ temp: e.target.value })} defaultValue={this.state.temp}>
												<option value={1}>De 0° à 8°C</option>
												<option value={2}>De 8° à 16°C</option>
												<option value={3}>De 16° à 22°C</option>
												<option value={4}>De 22° à 28°C</option>
												<option value={5}>De 28° à 36°C</option>
												<option value={6}>36°C et +</option>
											</FormControl>
										</FormGroup>
									</Form>

									<br/>

									<strong>Réservations ajoutées :</strong><br/>
                  {this.state.scheduledReservations.length > 0 &&
                  <ReservationTable reservations={this.state.scheduledReservations}  selected={this.state.scheduledReservationsSelected} />
                  }
									<hr/>
									<FlightIndicator
										montgolfiere={Montgolfieres.findOne(this.state.montgolfiereId)}
										pilot={Meteor.users.findOne(this.state.flight.pilotId)}
										temp={this.state.temp}
										reservations={this.state.scheduledReservations}
									/>
									<hr/>
									<center>
										<Button bsStyle="primary" onClick={::this.prepareFlight}>Programmer</Button>
									</center>

								</BPanel>
							</Col>
						</Col>
					</div>
				}
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/PlanningProgrammePage.js
 **/